<template>
	<div>
		<el-header class="el-header">
			<div class="el-header-left">
				<div class="ele-logo">
					<el-image :src="logo" style="width: 42px; height: 42px;border-radius: 50%;"></el-image>
					<span slot="title">{{title}}</span>
					<div v-if="menuLayout!=1">
						<div v-if="menuLayout!=1">
							<i v-if='!isCollapse' @click="changeMenu" class="el icon-right-indent"></i>
							<i v-else @click="changeMenu" class="el icon-left-indent"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="el-header-model">
				<el-scrollbar class="scroll-container">
					<el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" router unique-opened
						v-if="menuLayout==1">
						<template v-for="(item,index) in menu">
							<el-menu-item v-if="!item.child" :key="item.id" :index="item.href">
								<i :class="[item.icon ? item.icon : '']"></i>
								<span slot="title">{{ item.title }}</span>
							</el-menu-item>
							<el-submenu v-else :key="item.id" :index="item.id+''">
								<template slot="title">
									<i :class="[item.icon ? item.icon :'']"></i>
									<span>{{ item.title }}</span>
								</template>
								<MenuTree :dataList="item.child"></MenuTree>
							</el-submenu>
						</template>
					</el-menu>
					<el-menu class="el-menu-demo" mode="horizontal" router unique-opened v-if="menuLayout==2"
						background-color="">
						<template v-for="(item,index) in menu">
							<el-menu-item :key="item.id" @click="changeItem(item)"
								:class="{isActive:($route.path.indexOf(item.href)!=-1)}">
								<i :class="[item.icon ? item.icon : '']"></i>
								<span slot="title">{{ item.title }}</span>
							</el-menu-item>
						</template>
					</el-menu>
				</el-scrollbar>
			</div>
			<div class="el-header-right">
				<el-tooltip class="item" effect="dark" content="刷新" placement="top-start">
					<span>
						<i class="el-icon-refresh-right" @click="refresh"></i>
					</span>
				</el-tooltip>
				<el-tooltip class="item" effect="dark" content="清理缓存" placement="top-start">
					<span>
						<i class="el-icon-delete" @click="clearcache"></i>
					</span>
				</el-tooltip>
				<el-tooltip class="item" effect="dark" :content="isFull?'取消全屏':'全屏'" placement="top-start">
					<span>
						<i :class="isFull?'el icon-Exitfullscreen':'el icon-full-screen'" @click="fullScreen"></i>
					</span>
				</el-tooltip>
				<el-avatar :src="user.photo" :size="30"></el-avatar>
				<el-dropdown @command="clickCom" class="item">
					<span class="el-dropdown-link">
						{{user.user}}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="selfinfo">个人信息</el-dropdown-item>
						<el-dropdown-item command="changepwd">修改密码</el-dropdown-item>
						<el-dropdown-item command="loginout">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-tooltip class="item right" effect="dark" content="设置" placement="top-start">
					<span>
						<i class="el-icon-menu" @click="theme"></i>
					</span>
				</el-tooltip>
			</div>
		</el-header>
		<el-drawer title="主题设置" :visible.sync="drawer" size="30%">
			<ThemeConfig @themeChange="themeChange" @changeLayout="changeLayout" />
		</el-drawer>
		<el-dialog title="修改密码" :visible.sync="dialog" width="35%">
			<el-form :model="loginForm" status-icon :rules="rules" ref="ruleForm" label-width="20%"
				class="demo-ruleForm">
				<el-form-item label="原密码" prop="oldpassword">
					<el-input type="password" v-model="loginForm.oldpassword" autocomplete="off"
						show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newpassword">
					<el-input type="password" v-model="loginForm.newpassword" autocomplete="off"
						show-password></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmpassword">
					<el-input type="password" v-model="loginForm.confirmpassword" autocomplete="off"
						show-password></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import screenfull from 'screenfull'
	import store from '../../store'
	import ThemeConfig from '../../components/ThemeConfig.vue'
	import {
		validUsername,
		validPassword
	} from '@/utils/validate'
	import MenuTree from '@/components/MenuTree'
	import ScrollPane from './ScrollPane'
	import {
		updateThemeColor
	} from '../../utils/theme'
	import {
		bgColorConfig,
		CreateCss
	} from '../../utils/themecolor.js'
	export default {
		components: {
			ThemeConfig,
			MenuTree,
			ScrollPane
		},
		props: ['isCollapse'],
		inject: ["reload"], //子页面注入父页面方法
		data() {
			var validatePass = (rule, value, callback) => {
				if (!validPassword(value)) {
					callback(new Error('用户密码必须是字母、数字、下划线组合，且长度6-18位'))
				} else {
					callback()
				}
			};
			return {
				menu: store.state.menuModule.dymenuList,
				isFull: false,
				user: store.state.loginModule.userInfo,
				drawer: false,
				size: 'small',
				dialog: false,
				title: store.state.menuModule.logoInfo.logotitle,
				logo: store.state.menuModule.logoInfo.logo,
				loginForm: {
					oldpassword: '',
					newpassword: '',
					confirmpassword: ''
				},
				rules: {
					newpassword: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					confirmpassword: [{
						validator: validatePass,
						trigger: 'blur'
					}],
				},
			};
		},
		computed: {
			menuLayout() {
				return store.state.settings.theme.menuLayout;
			},
		},
		mounted() {
			let localtheme = localStorage.getItem('theme');
			if (localtheme) {
				let theme = JSON.parse(localtheme);
				this.themeChange(theme.theme || '#409EFF')
				this.changeLayout(theme.menuLayout || 0)
				CreateCss(theme.themecolor || 0)
			} else {
				this.themeChange('#409EFF')
				this.changeLayout(0)
				CreateCss(0)
			}
		},
		methods: {
			changeItem(e) {
				//点击切换按钮的时候 修改父组件的数据 menu
				this.$emit('changeItem', e)
			},
			changeMenu() {
				//点击切换按钮的时候 修改父组件的数据 isCollapse
				this.$emit('changeCollapse')
			},
			themeChange(val) {
				let theme = JSON.parse(localStorage.getItem('theme')) || store.state.settings.theme;
				theme.theme = val;
				store.dispatch('settings/changeSetting', theme)
				updateThemeColor(val)
			},
			changeLayout(val) {
				let theme = JSON.parse(localStorage.getItem('theme')) || store.state.settings.theme;
				theme.menuLayout = val;
				store.dispatch('settings/changeSetting', theme)
				if (val == 0) {
					this.$emit('changeItem', this.menu)
				}
				if (val == 2) {
					this.$emit('changeItem', [])
				}
			},
			async clearcache() {
				await this.$http.get('index/clearcache').then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
				}).catch(error => {
					console.log(error);
				});
			},
			clickLang(command) {
				this.$i18n.locale = command;
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						//请求登录接口------------- 
						if (this.loginForm.newpassword != this.loginForm.confirmpassword) {
							this.$message.error('两次密码不一致');
							return;
						}
						this.$http.post('manage.user_info/changepwd', this.loginForm).then(res => {
							if (res.code == 200) {
								this.$message({
									message: res.msg,
									type: "success"
								});
								this.dialog = false;
							} else {
								//账号或者密码错误
								this.$message.error(res.msg);
							}
						})

					} else {
						return false;
					}
				});
			},
			clickCom(command) {
				switch (command) {
					case "selfinfo":
						this.$router.push("/manage/selfinfo");
						break;
					case "changepwd":
						this.loginForm = {
							oldpassword: '',
							newpassword: '',
							confirmpassword: ''
						};
						this.dialog = true;
						break;
					case "loginout":
						store.commit('loginModule/clearUser');
						store.commit('menuModule/clearasyncMenu');
						localStorage.removeItem("user");
						// 清理 sessionStorage 中的 tabsView
						sessionStorage.removeItem("tabsView");
						store.state.tabsModule.tabList = [] //置空避免下个用户登录存在上个用户打开的tab
						//返回登录
						this.$router.push("/login");
						break;
				}
			},
			theme() {
				this.drawer = true;
			},
			refresh() {
				this.reload() //调用父页面注入的方法实现刷新
			},
			fullScreen() {
				if (!screenfull.enabled) {
					this.$message({
						message: "不支持全屏",
						type: "warning"
					});
					this.isFull = !this.isFull;
					return false;
				}
				screenfull.toggle();
				this.isFull = !this.isFull
			},
		}
	}
</script>

<style lang='less' scoped>
	.el-header {
		height: 50px;
		line-height: 50px;

		/*display: flex;
		align-items: center;  垂直居中 */
		.el-dropdown-link {
			margin-right: 5px;
		}		

		.el-header-left {
			left: 0px;
			float: left;
			display: flex;
			.ele-logo {
				height: 60px;
				transition: width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s, left 0.3s cubic-bezier(0.2, 0, 0, 1) 0s, box-shadow 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
				font-size: 20px;
				white-space: nowrap;
				position: relative;
				overflow: hidden;
				flex-shrink: 0;
				display: flex;
				font-weight: 600;
				align-items: center;
				justify-content: center;
				font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
				cursor: pointer;
			}
			
			i {
				font-size: 20px;
			}

			span {
				
			}
		}

		.el-header-model {
			flex: 1;
			min-width: 0;
			/* 重要：允许内容收缩 */
			width: 45%;
			height:60px;
			position: relative;
			overflow-x: auto;
			overflow-y: hidden;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding: 0 15px;

			.scroll-container {
				width: 100%;
				height: 60px;
				/deep/ .el-scrollbar__wrap {
					overflow-x: auto;
					overflow-y: hidden;
				}

				.el-menu-demo {
					display: inline-flex;
					height: 100%;
					border: none;
					white-space: nowrap;
					 /*.el-menu-item{
						display: inline-flex;
						float: none;
						height: 100%;
						line-height: 50px;
					} */
				}
			}
		}

		.el-header-right {
			position: absolute !important;
			right: 5px;
			top: 0;
			float: right;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			min-width: 300px;
			/* 确保有足够空间显示功能图标 */
			/* 确保内部元素垂直居中 */
			.item {
				padding-right: 25px;
				font-size: 15px;

				span {
					margin-right: 5px;
				}

				i {
					font-size: 16px;
				}

				i:hover {
					color: #fff;
				}

				.el {
					font-size: 13px;
				}

				.right {
					margin-right: 5px;
				}
			}
		}
	}
	/* 响应式设计 */
		@media (max-width: 1200px) {
			.el-header {
				.el-header-right {
					min-width: 250px;
					
					.item {
						margin-left: 12px;
					}
				}
			}
		}
		
		@media (max-width: 992px) {
			.el-header {
				.el-header-left .ele-logo .title-text {
					display: none;
				}
				
				.el-header-right {
					min-width: 200px;
					
					.item:not(:last-child):not(.right) {
						display: none;
					}
				}
			}
		}
		
		@media (max-width: 768px) {
			.el-header {
				.ele-logo {
					min-width: auto;
				}
				
				.el-header-model {
					padding: 0 5px;
				}
				
				.el-header-right {
					min-width: auto;
					
					.item {
						margin-left: 8px;
					}
					
					.el-avatar {
						display: none;
					}
					
					.username {
						display: none;
					}
				}
			}
		}
		
		@media (max-width: 480px) {
			.el-header {
				.el-header-left {
					min-width: 40px;
					.ele-logo {
						.collapse-icon {
							margin-left: 5px;
						}
					}
				}
				
				.el-header-right {
					.right {
						display: none;
					}
				}
			}
		}
</style>